import { z } from 'zod';

export const timelineDataPointSchema = z.object({
  timestamp: z.string(),
  sent: z.number(),
  delivered: z.number(),
  failed: z.number(),
});
export type TimelineDataPoint = z.infer<typeof timelineDataPointSchema>;

export const byProviderSchema = z.object({
  providerId: z.string(),
  failures: z.number(),
});

export const byChannelVolumeSchema = z.object({
  channel: z.string(),
  volume: z.number(),
});

export const metricsTimelineSchema = z.object({
  points: z.array(timelineDataPointSchema),
  byProvider: z.array(byProviderSchema),
  byChannel: z.array(byChannelVolumeSchema),
});
export type MetricsTimeline = z.infer<typeof metricsTimelineSchema>;
